import { Observable } from 'rxjs';
import {DoorCorners, ScenarioImage, ScenarioImageCustomData} from '../../models/scenario-image';
import {DeviceType} from "../../../generated/graphql";

export type Orientation = 'VERTICAL' | 'HORIZONTAL';

export interface UploadScenarioArgs {
  customerKey: string,
  file: File,
  doorTypeId?: string,
  deviceType?: DeviceType
}

export abstract class ScenarioImageLoader {

  abstract deleteUserScenarioForAppUser(userScenarioShortId: string): Observable<ScenarioImage[]>;

  abstract loadExampleImages(args: { customerKey: string, doorTypeId: string, orientation?: Orientation, setNumber?: number }): Observable<ScenarioImage[]>;

  abstract loadUserScenarioImageByShortId(shortId: string): Observable<ScenarioImage>;

  abstract loaderUserScenarioForAppUser(): Observable<ScenarioImage[]>

  abstract uploadUserScenario(args: UploadScenarioArgs):Observable<{ scenarioImage: ScenarioImage, showRefineLayout: boolean }>;

  abstract updateCorners(id: string, corners: Array<DoorCorners>, customData?: ScenarioImageCustomData): Observable<ScenarioImage>;
}
